import React from 'react';
import SectionText from '../presentational/SectionText';
import Video from '../presentational/Video';
import data from '../../core/data';

function TodayTonight(props) {
  return (
    <section id="todaytonight" className="dark animated">
      <div className="container">
        <div className="row">
          <div className="col-md-4 body">
            <SectionText heading='As Seen on "Today Tonight"'>
              <p><b>Herbal Aktiv Peel</b>® was featured on popular news show "Today Tonight" to much acclaim.</p>
            </SectionText>
          </div>
          <div className="col-md-7 col-md-offset-1 video">
            <Video src="https://www.youtube.com/embed/QZJomgBMKM4" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default TodayTonight;



/** WEBPACK FOOTER **
 ** ./src/components/containers/TodayTonight.jsx
 **/